import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Reference, Property, Name, Output } from '@components/Reference';
import { Spacer } from "@cleartrip/bento/lib";
import Sandbox from '@components/Sandbox';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <h1 {...{
      "id": "spacing"
    }}>{`Spacing`}</h1>
    <p>{`Used to define spacing values`}</p>
    <h2 {...{
      "id": "custom-scale"
    }}>{`Custom scale`}</h2>
    <p>{`Our spacing values are derived from our 4px baseline grid. Instead of using pixels, we have defined our own custom units and a new scale. This helps us in abstracting away from the technical details and ensuring scalability across products.`}</p>
    <p>{`With our new scale, spacing units are set in multiples of 4 i.e. 1 unit = 4px.`}</p>
    <h2 {...{
      "id": "class-reference"
    }}>{`Class Reference`}</h2>
    <p>{`Spacing classes take on the syntax of `}<inlineCode parentName="p">{`.{property}-{spacing value}`}</inlineCode>{`. Spacing values can range from `}<strong parentName="p">{`0-15`}</strong>{` i.e. 0px - 60px.`}</p>
    <h2 {...{
      "id": "margin"
    }}>{`Margin`}</h2>
    <Reference mdxType="Reference">
    <Property mdxType="Property">
        <Name mdxType="Name"> .m-1 </Name>
        <Output mdxType="Output">margin: 4px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .mt-1 </Name>
        <Output mdxType="Output">margin-top: 4px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .mr-1 </Name>
        <Output mdxType="Output">margin-right: 4px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .mb-1 </Name>
        <Output mdxType="Output">margin-bottom: 4px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .ml-1 </Name>
        <Output mdxType="Output">margin-left: 4px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .mx-1 </Name>
        <Output mdxType="Output">margin-left: 4px; <br /> <br />
        margin-right: 4px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .my-1 </Name>
        <Output mdxType="Output">margin-top: 4px; <br /> <br />
        margin-bottom: 4px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .nmt-1 </Name>
        <Output mdxType="Output">margin-top: -4px; </Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .nmr-1 </Name>
        <Output mdxType="Output">margin-right: -4px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .nmb-1 </Name>
        <Output mdxType="Output">margin-bottom: -4px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .nml-1 </Name>
        <Output mdxType="Output">margin-left: -4px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .nmx-1</Name>
        <Output mdxType="Output">margin-left: -4px; <br /> <br />
        margin-right: -4px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .nmy-1 </Name>
        <Output mdxType="Output">margin-top: -4px; <br /> <br />
        margin-bottom: -4px;</Output>
    </Property>
        <Property mdxType="Property">
        <Name mdxType="Name"> .m-auto</Name>
        <Output mdxType="Output">margin: auto;</Output>
    </Property>
    </Reference>
    <h3 {...{
      "id": "example"
    }}>{`Example`}</h3>
    <Spacer my={2} mdxType="Spacer" />
    <Sandbox mdxType="Sandbox">
    <Sandbox.Preview>
        <div className="bs-auto br-no-repeat w-100p" style={{
          height: '50px'
        }}>
            <div className="bs-solid">
                <div className="bg-primary-400 c-grey-80 mr-2 mt-12 ml-8">This is a box with some margin applied</div>
            </div>
        </div>
    </Sandbox.Preview>
      <Sandbox.Code>
            <div className="mr-2 mt-12 ml-4">
            </div>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "padding"
    }}>{`Padding`}</h2>
    <Reference mdxType="Reference">
    <Property mdxType="Property">
        <Name mdxType="Name"> .p-1 </Name>
        <Output mdxType="Output">padding: 4px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .pt-1 </Name>
        <Output mdxType="Output">padding-top: 4px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .pr-1 </Name>
        <Output mdxType="Output">padding-right: 4px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .pb-1 </Name>
        <Output mdxType="Output">padding-bottom: 4px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .pl-1 </Name>
        <Output mdxType="Output">padding-left: 4px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .px-1 </Name>
        <Output mdxType="Output">padding-left: 4px; <br /> <br />
        padding-right: 4px;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name"> .py-1 </Name>
        <Output mdxType="Output">padding-top: 4px; <br /> <br />
        padding-bottom: 4px;</Output>
    </Property>
    </Reference>
    <h3 {...{
      "id": "example-1"
    }}>{`Example`}</h3>
    <Spacer my={2} mdxType="Spacer" />
    <Sandbox mdxType="Sandbox">
    <Sandbox.Preview>
        <div className="bs-auto br-no-repeat w-100p" style={{
          height: '50px'
        }}>
            <div className="bs-solid">
                <div className="bg-primary-400 c-grey-80 pt-4 pb-1 pl-1 pr-2">This is a box with some padding applied</div>
            </div>
        </div>
    </Sandbox.Preview>
      <Sandbox.Code>
            <div className="pt-4 pb-1 pl-1 pr-2">
            </div>
  </Sandbox.Code>
    </Sandbox>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      